import {} from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    marginTop: '24px',
  },
  collectionTitleStyle: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#002E47',
    marginBottom: '3px',
    fontFamily: 'Inter',
  },
  editableTitle: {
    color: '#002E47',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontWeight: 600,
    padding: 0,
    border: 'none',
    background: 'transparent',
    minWidth: '100px',
    maxWidth: '70vw',
    width: 'auto',
    outline: 'none',
    '&:focus': {
      outline: 'none',
    },
    '&:hover': {
      outline: 'none',
    },
  },
})

export default styles
